import { useCallback } from 'react';
import { useLocation } from 'react-router-dom';
import { useLanguage } from '../context';
import { getLanguageFromURL, isLanguageSupported } from '../config/languages';
import { getLocalStorage, languageStorage } from '../helpers/localStorage';

export const useLanguageSync = () => {
  const { pathname } = useLocation();
  const { language, changeLanguage } = useLanguage();

  const syncLanguageWithURL = useCallback(async () => {
    const storedLanguage = getLocalStorage(languageStorage);
    if (storedLanguage && isLanguageSupported(storedLanguage)) {
      return;
    }

    const urlLanguage = getLanguageFromURL(pathname);
    
    if (urlLanguage && urlLanguage !== language) {
      await changeLanguage(urlLanguage);
    }
  }, [pathname, language, changeLanguage]);

  return { syncLanguageWithURL };
};

export const useLanguageDetection = () => {
  const { changeLanguage } = useLanguage();

  const detectAndSetLanguage = useCallback(async () => {
    const urlLanguage = getLanguageFromURL(window.location.pathname);
    
    if (urlLanguage) {
      await changeLanguage(urlLanguage);
      return urlLanguage;
    }
    
    return null;
  }, [changeLanguage]);

  return { detectAndSetLanguage };
};